import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import NavBar from '../components/NavBar/NavBar.js'
import NavPane from '../components/NavPane/NavPane.js'
import Grid from '../components/Grid/Grid.js'
import { supabase } from '../supabaseClient'

const Category = () => {
  const [videos, setVideos] = useState([])
  const [visibleNoVideoAlert, setVisibleNoVideoAlert] = useState(false)

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const categoryName = queryParams.get('cat') || ''

  const getVideosArray = async () => {
    if (!categoryName) return

    try {
      // NOTE: 'Category' is Capitalized here to match your exact Supabase column
      const { data, error } = await supabase
        .from('videos')
        .select('*')
        .ilike('Category', `%${categoryName}%`)

      if (error) {
        console.error('Supabase Query Error:', error)
        setVisibleNoVideoAlert(true)
        return
      }

      if (!data || data.length === 0) {
        setVideos([])
        setVisibleNoVideoAlert(true)
      } else {
        setVideos(data)
        setVisibleNoVideoAlert(false)
      }
    } catch (err) {
      console.error('Unexpected error:', err)
      setVisibleNoVideoAlert(true)
    }
  }

  useEffect(() => {
    getVideosArray()
  }, [categoryName, location.search])

  return (
    <div className="w-full h-full flex flex-col overflow-hidden">
      <NavBar activePage={categoryName} />
      <div className="flex flex-row pt-5 flex-1 w-full h-full overflow-hidden">
        <NavPane activePage={categoryName} />
        <div className="flex-1 p-4 overflow-y-auto">
          {visibleNoVideoAlert ? (
            <div className="text-2xl font-semibold text-gray-600 w-fit relative top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              No videos found in {categoryName}
            </div>
          ) : (
            <Grid videos={videos} setVideos={setVideos} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Category
